module.exports = __webpack_public_path__ + "img/文字_A级赛事@2x.3ec7cde1.png";